import { gql } from '@apollo/client/core';
import useQuery from '../../hooks/useQuery';

export interface VirtualTenant {
  uuid: string;
  code: string;
  tenantCode: string;
}

export const GET_VIRTUAL_TENANTS_BY_TENANT = gql`
  query getVirtualTenantsByTenant($tenant: String!) {
    virtualTenantsByTenant(tenant: $tenant) {
      uuid
      code
      tenantCode
    }
  }
`;

export const useGetVirtualTenantsByTenant = (tenant: string) => {
  const { data, isLoading, error } = useQuery<VirtualTenant[]>({
    query: GET_VIRTUAL_TENANTS_BY_TENANT,
    variables: { tenant },
    responseField: 'virtualTenantsByTenant',
  });

  return {
    virtualTenants: data || [],
    isLoading,
    error,
  };
};
